import { InputIcon, InputOptions, NullableTextInput } from '@tempots/beatui'

export function PhoneNumberInput(options: InputOptions<string | null>) {
  return NullableTextInput({
    before: InputIcon({ icon: 'line-md:phone-twotone' }),
    placeholder: '(555) 555-5555',
    ...options,
  })
}
